"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createRequests;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _utils = require("./utils");
var _excluded = ["body", "getBody", "headers"];
function createDefaultRequestManager() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp;
  var defaultRequests = Object.create(Object.prototype, {});
  function defaultGetHTTPOptions() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p$bodyJson = p.bodyJson,
      bodyJson = _p$bodyJson === void 0 ? {} : _p$bodyJson,
      _p$options = p.options,
      options = _p$options === void 0 ? {} : _p$options;
    return (0, _objectSpread2["default"])({
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(bodyJson),
      credentials: "same-origin"
    }, options);
  }
  function defaultSetNewRequest() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var requestName = p.requestName;
    if (requestName) {
      requestManager.requests[requestName] = requestManager.createRequest(p);
    }
  }
  function defaultCreateRequest() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = p.url;
    if (url) {
      return {
        url: url,
        options: requestManager.getHTTPOptions(p)
      };
    }
    return requestManager.getHTTPOptions(p);
  }
  function defaultSendRequest() {
    return _defaultSendRequest.apply(this, arguments);
  }
  function _defaultSendRequest() {
    _defaultSendRequest = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
      var _p$req, _p$req$wappRequest;
      var p,
        wapp,
        fetch,
        requestName,
        req,
        _p$formatBeforeReques,
        formatBeforeRequest,
        request,
        url,
        _request$options,
        options,
        body,
        getBody,
        headers,
        restOptions,
        requestBody,
        cookie,
        response,
        _args = arguments;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            p = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            wapp = requestManager.wapp;
            fetch = ((_p$req = p.req) === null || _p$req === void 0 ? void 0 : (_p$req$wappRequest = _p$req.wappRequest) === null || _p$req$wappRequest === void 0 ? void 0 : _p$req$wappRequest.fetch) || requestManager.fetch;
            if (!fetch && typeof window !== "undefined" && window.fetch) {
              fetch = window.fetch;
            }
            if (p.fetch) {
              fetch = p.fetch;
            }
            requestName = p.requestName, req = p.req, _p$formatBeforeReques = p.formatBeforeRequest, formatBeforeRequest = _p$formatBeforeReques === void 0 ? function (url, options) {
              return [url, options];
            } : _p$formatBeforeReques;
            request = requestName && requestManager.requests[requestName] ? requestManager.requests[requestName] : p.request ? p.request : null;
            url = request.url, _request$options = request.options, options = _request$options === void 0 ? {} : _request$options;
            body = options.body, getBody = options.getBody, headers = options.headers, restOptions = (0, _objectWithoutProperties2["default"])(options, _excluded);
            requestBody = typeof getBody == "function" ? getBody((0, _objectSpread2["default"])({
              wapp: wapp
            }, p)) : body;
            cookie = req && req.headers ? req.headers.cookie : null;
            response = null;
            _context.prev = 12;
            _context.next = 15;
            return fetch.apply(void 0, (0, _toConsumableArray2["default"])(formatBeforeRequest(url, (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
              headers: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, cookie ? {
                cookie: cookie
              } : {}), headers)
            }, restOptions), {}, {
              body: requestBody
            }), p)));
          case 15:
            response = _context.sent;
            if (!(response && response.json)) {
              _context.next = 20;
              break;
            }
            _context.next = 19;
            return response.json();
          case 19:
            response = _context.sent;
          case 20:
            if (response && response.data && !response.errors && !response.error) {
              response = response.data;
            }
            return _context.abrupt("return", response);
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](12);
            console.log(_context.t0);
            return _context.abrupt("return", {
              error: _context.t0
            });
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[12, 24]]);
    }));
    return _defaultSendRequest.apply(this, arguments);
  }
  var requestManager = Object.create(Object.prototype, {
    wapp: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      enumerable: false,
      value: wapp
    }),
    getHTTPOptions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultGetHTTPOptions
    }),
    setNewRequest: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultSetNewRequest
    }),
    createRequest: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultCreateRequest
    }),
    sendRequest: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultSendRequest
    }),
    requests: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      writable: false,
      value: defaultRequests
    })
  });
  return requestManager;
}
function createRequests() {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var wapp = p.wapp,
    _p$requestManager = p.requestManager,
    requestManager = _p$requestManager === void 0 ? createDefaultRequestManager(p) : _p$requestManager;
  function defaultHandle(req, res, next) {
    next();
  }
  function defaultSend(_x) {
    return _defaultSend.apply(this, arguments);
  }
  function _defaultSend() {
    _defaultSend = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2(p) {
      var res, response;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            res = p.res;
            _context2.next = 3;
            return requestManager.sendRequest(p);
          case 3:
            response = _context2.sent;
            if (res && res.wappResponse.store && response) {
              res.wappResponse.store.dispatch(wapp.states.stateManager.actions.res({
                type: "INS_RES",
                name: "responses",
                value: response
              }));
            }
            return _context2.abrupt("return", response);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _defaultSend.apply(this, arguments);
  }
  var requestsMiddlewareProperties = Object.create(Object.prototype, {
    handle: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultHandle
    }),
    send: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: defaultSend
    }),
    requestManager: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
      value: requestManager
    })
  });
  function requestsMiddleware(req, res, next) {
    if (typeof requestsMiddleware.handle === "function") {
      requestsMiddleware.handle(req, res, next);
    }
    return requestsMiddleware;
  }
  (0, _utils.mergeProperties)(requestsMiddleware, requestsMiddlewareProperties);
  Object.defineProperty(requestsMiddleware, "wapp", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    enumerable: false,
    value: wapp
  }));
  Object.defineProperty(wapp, "requests", (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, _utils.defaultDescriptor), {}, {
    writable: false,
    value: requestsMiddleware
  }));
  return requestsMiddleware;
}